import { http } from "./http";

export const fetchTranslations = async (locale) => {
    try {
        const response = await http.get(`translations/${locale}`);
        return response.data;
    } catch {
        console.error('Failed to fetch translations');
        return {};
    }
};